VjsAdmin.RosterMapping = (() => {
    const me = {
        platformId: '',
        rosteringType: '',
        mappingFields: '',
        oneRosterMappingFields: [],
        queueKey: '',
        queueStatus: '',
    };

    const cleverMappingTemplate = '/assets/templates/admin-tools/roster-mapping/choose-district-component-template.html';
    const oneRosterMappingTemplate = '/assets/templates/admin-tools/roster-mapping/oneroster-mapping-component-template.html';
    const googleMappingTemplate = '/assets/templates/admin-tools/roster-mapping/google-mapping-component-template.html';
    const init = () => {
        const rosterMappingView = new RosterMappingView();
        rosterMappingView.render();
        applyGetParams();
    };
    const RosterMappingView = VjsUtility.View.extend({
        parent: '#task-settings',
        templateUrl: '/assets/templates/admin-tools/roster-mapping/roster-mapping-template.html',
        events: {
            'click #analyze-mapping': 'clickAnalyzeMapping',
            'change #choose-rostering-type': 'changeRosteringType',
        },
        changeRosteringType() {
            const chooseDistrictView = new ChooseDistrictView();
            switch ($('#choose-rostering-type').val()) {
                case 'CleverSync':
                    me.rosteringType = 'CleverSync';
                    chooseDistrictView.templateUrl = cleverMappingTemplate;
                    chooseDistrictView.fetch({ rostering_type: 'clever' }, 'post');
                    break;
                case 'OneRoster':
                    me.rosteringType = 'OneRoster';
                    chooseDistrictView.templateUrl = oneRosterMappingTemplate;
                    chooseDistrictView.fetch({ rostering_type: 'oneroster' }, 'post');
                    break;
                case 'Google':
                    me.rosteringType = 'Google';
                    chooseDistrictView.templateUrl = googleMappingTemplate;
                    chooseDistrictView.fetch({ rostering_type: 'google' }, 'post');
                    break;
                default:
                    break;
            }
        },
        clickAnalyzeMapping(e) {
            e.preventDefault();
            $('#mapping-error').detach();
            me.oneRosterMappingFields = [];

            // Front end validation for all mapping fields
            const errors = validateMappingFields(me.rosteringType);
            if (errors) {
                return false;
            }

            // show loading div
            $('.results-loading').show();
            $('#results-card').detach();
            const districtData = $('.district-select2').select2('data')[0];
            if (!districtData) {
                VjsUtility.Notification.error({
                    text: 'Select a district',
                    time: 5000, // in milliseconds
                });
                $('.results-loading').hide();
                return false;
            }
            if (typeof me.oneRosterMappingFields === 'object' && (me.rosteringType === 'OneRoster' || me.rosteringType === 'Google')) {
                me.mappingFields = me.oneRosterMappingFields;
            }

            const mappingParams = {
                district_joint_guid: districtData.id,
                rostering_type: me.rosteringType,
                mapping_field: me.mappingFields,
                platform_id: $('#platform-select').val(),
                role_mappings: $('#role-mappings :input').serializeArray(),
            };
            me.platformId = mappingParams.platformId;
            if (me.rosteringType === 'OneRoster' || me.rosteringType === 'Google') {
                const url = '/admin/bulk-tasks/roster_mapping/run';
                // eslint-disable-next-line no-undef
                fetchRetry(url, mappingParams, (retries = 100), (backoff = 5000));
            }
            if (me.rosteringType === 'CleverSync') {
                const url = '/admin/bulk-tasks/roster_mapping/run';
                // eslint-disable-next-line no-undef
                fetchRetry(url, mappingParams, (retries = 100), (backoff = 5000));
            }
        },
    });

    function validateMappingFields(rosteringType) {
        let errors = false;
        // Field Mapping fields for cleversync
        if ($('#field-mappings :input').serializeArray() === '' && rosteringType === 'CleverSync') {
            $('.field-mappings').removeClass('is-valid').addClass('is-invalid');
            $('#field-mappings-invalid').show();
            errors = true;
        } else {
            $('.field-mappings').removeClass('is-invalid');
            $('#field-mappings-invalid').hide();
            me.mappingFields = $('#field-mappings :input').serializeArray();
        }

        // Field Mapping fields for oneroster && Google
        if ($('#vjs-mapping-field').val() === '' && (rosteringType === 'OneRoster' || rosteringType === 'Google')) {
            $('#vjs-mapping-field').removeClass('is-valid').addClass('is-invalid');
            $('#oneroster-vjs-field-mappings-invalid').show();
            errors = true;
        } else {
            $('#vjs-mapping-field').removeClass('is-invalid');
            $('#oneroster-vjs-field-mappings-invalid').hide();
            // add valid field to global mapping fields
            me.oneRosterMappingFields.push({
                name: 'vjs_mapping_field',
                value: $('#vjs-mapping-field').val(),
            });
        }
        // Field Mapping fields for OneRoster
        if ($('#oneroster-mapping-field').val() === '' && rosteringType === 'OneRoster') {
            $('#oneroster-mapping-field').removeClass('is-valid').addClass('is-invalid');
            $('#oneroster-field-mappings-invalid').show();
            errors = true;
        } else {
            $('#oneroster-mapping-field').removeClass('is-invalid');
            $('#oneroster-field-mappings-invalid').hide();
            // add valid field to global mapping fields
            me.oneRosterMappingFields.push({
                name: 'oneroster_mapping_field',
                value: $('#oneroster-mapping-field').val(),
            });
        }

        // OneRoster and CleverSync and Google validation fields
        if ($('#choose-rostering-type').val() === '') {
            $('#choose-rostering-type').removeClass('is-valid').addClass('is-invalid');
            $('#roster-type-invalid').show();
            errors = true;
        } else {
            $('#choose-rostering-type').removeClass('is-invalid');
            $('#roster-type-invalid').hide();
        }
        if ($('#role-mappings :input').serializeArray() === '') {
            $('.role-mappings').removeClass('is-valid').addClass('is-invalid');
            $('#role-mappings-invalid').show();
            errors = true;
        } else {
            $('.role-mappings').removeClass('is-invalid');
            $('#role-mappings-invalid').hide();
        }
        if ($('.district-select2').select2('data') === 'undefined' || $('.district-select2').select2('data') === '') {
            $('.district-select').removeClass('is-valid').addClass('is-invalid');
            $('#district-invalid').show();
            errors = true;
        } else {
            $('.district-select').removeClass('is-invalid');
            $('#district-invalid').hide();
        }
        return errors;
    }

    function fetchRetry(url, options = {}, retries = 100, backoff = 100000) {
        // This is a method to keep retrying to see if the queue has completed. If it has then it displays the results template. If it hasnt then it displays an error.
        const req = new VjsUtility.Request();
        return req
            .post(url, options)
            .done((res) => {
                me.queueStatus = res.queueStatus;
                if (+retries === 100) {
                    me.queueKey = res.queueKey;
                }
                if (retries > 0 && (me.queueStatus === 'queued' || me.queueStatus === 'processing')) {
                    const queueData = {
                        rostering_type: me.rosteringType,
                        queue_key: me.queueKey,
                    };
                    setTimeout(() => fetchRetry('/admin/bulk-tasks/roster_mapping/getQueue', queueData, retries - 1, backoff), backoff);
                }
                if (me.queueStatus === 'completed') {
                    const queueData = {
                        rostering_type: me.rosteringType,
                        queue_key: me.queueKey,
                    };
                    const request = new VjsUtility.Request();
                    request
                        .post('/admin/bulk-tasks/roster_mapping/getMappingResults', queueData)
                        .done((response) => {
                            const data = {
                                mapped_users: JSON.parse(response.mapped_users),
                                mapping_key: response.mapping_key,
                                non_mapped_users: JSON.parse(response.non_mapped_users),
                                user_stats: JSON.parse(response.user_stats),
                            };
                            const parsedResults = parseMappingResults(data);
                            const rosterMappingResultsView = new RosterMappingResultsView();
                            rosterMappingResultsView.nonMatchedUsers = JSON.parse(response.non_mapped_users);
                            rosterMappingResultsView.render(parsedResults);
                        })
                        .fail((err) => {
                            console.log('error getting mapping results', err);
                        })
                        .always(() => {
                            $('.results-loading').hide();
                        });
                }
                if (me.queueStatus === 'error') {
                    const queueData = {
                        rostering_type: me.rosteringType,
                        queue_key: me.queueKey,
                    };
                    const request = new VjsUtility.Request();
                    request
                        .post('/admin/bulk-tasks/roster_mapping/getMappingResults', queueData)
                        .done((error) => {
                            VjsUtility.Notification.error({
                                text: error.error_message,
                                time: 5000, // in milliseconds
                            });
                        })
                        .fail((err) => {
                            console.log('error getting mapping results', err);
                        })
                        .always(() => {
                            $('.results-loading').hide();
                        });
                }

                return res;
            })
            .fail((res) => {
                const parsedError = JSON.parse(res.responseText);
                VjsUtility.Notification.error({
                    text: parsedError.title || parsedError.message,
                    time: 5000, // in milliseconds
                });
            })
            .always(() => {
                $('.results-loading').hide();
            });
    }

    const ChooseDistrictView = VjsUtility.View.extend({
        parent: '#choose-district-component',
        templateUrl: '',
        dataUrl() {
            return '/districts/';
        },

        after() {
            const platformSelect = $('#platform-select');
            // platforms variable from bulk-tasks/index.twig
            // eslint-disable-next-line no-undef
            platforms.forEach((platform) => {
                platformSelect.append(`<option value="${platform.platform_id}">${platform.name}</option>`);
            });
            $('.district-select2').select2({
                ajax: {
                    type: 'POST',
                    url: Slim.Router.pathFor('districts.list.json'),
                    dataType: 'json',
                    delay: 250,
                    data(params) {
                        return {
                            search_term: params.term,
                            rostering_type: 'clever',
                        };
                    },
                    processResults(data) {
                        const newItems = data.data.map((item) => ({
                            id: item.district_joint_guid,
                            text: `${item.name} : ${item.district_id}`,
                        }));
                        return {
                            results: newItems,
                            pagination: {
                                more: false,
                            },
                        };
                    },
                },
                placeholder: 'Search for a district',
                minimumInputLength: 1,
                theme: 'bootstrap4',
            });
        },
    });

    const RosterMappingResultsView = VjsUtility.View.extend({
        nonMatchedUsers: [],
        parent: '#roster-mapping-results',
        templateUrl: '/assets/templates/admin-tools/roster-mapping/roster-mapping-results-component.html',
        dataUrl: '/admin/bulk-tasks/roster_mapping/run',
        parse(res) {
            const parsedResults = parseMappingResults(res);
            this.nonMatchedUsers = parsedResults.non_matched_users_array;
            return parsedResults;
        },
        // eslint-disable-next-line no-underscore-dangle
        _fail(error) {
            const parsedError = JSON.parse(error.responseText);
            // Since this tool is only used by devs I am leaving the console log here.
            console.log('Returned roster mapping error', parsedError);
            VjsUtility.Notification.error({
                text: parsedError.title || parsedError.message,
                time: 5000, // in milliseconds
            });
            $('.results-loading').hide();
        },
        events: {
            'click #view-non-matched-users': 'clickNonMatchedUsers',
            'click #save-results-btn': 'clickSaveMappingBtn',
            'click #cancel-results-btn': 'clickCancelMappingBtn',
        },
        clickNonMatchedUsers() {
            const percentRole = (userRole) => {
                let result = 0;
                this.nonMatchedUsers.forEach((user) => (user.role === userRole ? result++ : result));
                return Math.round((result / this.nonMatchedUsers.length) * 100);
            };

            const emptyFields = (fieldName) => {
                let results = 0;
                this.nonMatchedUsers.forEach((user) => (user[fieldName] === null ? results++ : results));
                return results;
            };
            const nonMatchedUserData = {
                non_matched_users: this.nonMatchedUsers,
                non_matched_stats: {
                    percentage_user_roles: percentRole('user'),
                    percentage_staff_roles: percentRole('staff'),
                    percentage_administrator_roles: percentRole('administrator'),
                    percentage_superadministrator_roles: percentRole('superadministrator') + percentRole('super_admin'),
                    empty_fields_username: emptyFields('username'),
                    empty_fields_sisid: emptyFields('sis_id'),
                    empty_fields_email: emptyFields('email'),
                    empty_fields_authssouserid: emptyFields('auth_ssouserid'),
                },
            };
            VjsUtility.Popup.init({
                title: 'Non Matched Users',
                templateUrl: '/assets/templates/admin-tools/roster-mapping/non-matched-users-popup-component.html',
                bodyClasses: 'non-matched-users',
                data: nonMatchedUserData,
            });
        },
        clickSaveMappingBtn: (e) => {
            const dataMappingKey = $(e.currentTarget).data('mapping-key');
            const params = {
                mapping_key: dataMappingKey,
                platform_id: me.platformId,
                rostering_type: me.rosteringType,
            };
            const req = new VjsUtility.Request();
            req.post('/admin/bulk-tasks/roster_mapping/save', params)
                .done((res) => {
                    $('#results-success-body').show();
                    if (res.errors) {
                        $('#results-success-body').append(' - With errors. See console log');
                    }
                    $('#results-body').hide();
                })
                .fail((error) => {
                    const parsedError = JSON.parse(error.responseText);
                    // Since this tool is only used by devs I am leaving the console log here.
                    console.log('Returned roster mapping error', parsedError);
                    VjsUtility.Notification.error({
                        text: parsedError.title || parsedError.message,
                        time: 5000, // in milliseconds
                    });
                })
                .always(() => {
                    $('.results-loading').hide();
                });
        },
        clickCancelMappingBtn: (e) => {
            const params = {
                mapping_key: $(e.currentTarget).data('mapping-key'),
                platform_id: me.platformId,
                rostering_type: me.rosteringType,
            };
            $('#results-card').detach();
            const req = new VjsUtility.Request();
            req.post('/admin/bulk-tasks/roster_mapping/delete', params).done(() => {});
        },
        after: (res) => {
            $('.results-buttons').attr('data-mapping-key', res.mapping_key);
            $('.results-loading').hide();
        },
    });

    function parseMappingResults(data) {
        if (typeof data.error !== 'undefined') {
            $('.results-loading').hide();
            $('.analyze-mapping-error').append(`<div id="mapping-error"><p>${data.error}</p></div>`);
            return null;
        }

        // here we are parsing the returned value so we can give stats to the users
        const nonMatchedUsers = data.non_mapped_users ? data.non_mapped_users.length : 0;
        const matchedUsers = data.mapped_users ? data.mapped_users.length : 0;
        const totalPlatformUsers = nonMatchedUsers + matchedUsers;
        const percentageMatched = Math.round((matchedUsers / totalPlatformUsers) * 100);
        const percentageNonMatched = Math.round((nonMatchedUsers / totalPlatformUsers) * 100);
        this.nonMatchedUsers = data.non_mapped_users;
        return {
            district_users: totalPlatformUsers,
            api_users: data.user_stats.api_users,
            matched_users: matchedUsers,
            percentage_matched: percentageMatched,
            non_matched_users: nonMatchedUsers,
            percentage_non_matched: percentageNonMatched,
            non_matched_users_array: data.non_mapped_users,
            mapping_key: data.mapping_key,
        };
    }

    const applyGetParams = () => {
        const queryString = window.location.search;

        if (queryString) {
            const urlParams = new URLSearchParams(queryString);

            const typeSelect = '#choose-rostering-type';
            waitForElement(typeSelect).then(() => {
                const task = urlParams.get('type');
                $(typeSelect).val(task).trigger('change');
            });

            const districtSelect = '.district-select2';
            waitForElement(districtSelect).then(() => {
                const districtJointGuid = urlParams.get('district-joint-guid');
                const districtId = urlParams.get('district-id');
                const districtName = urlParams.get('district-name');
                const districtOption = new Option(`${districtName}: ${districtId}`, districtJointGuid, true, true);
                $(districtSelect).append(districtOption).trigger('change');
            });

            const platformSelect = '#platform-select';
            waitForElement(platformSelect).then(() => {
                const platform = urlParams.get('platform');
                $(platformSelect).val(platform).trigger('change');
            });
        }
    };

    function waitForElement(selector) {
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(() => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    }

    return {
        init,
    };
})();
